/**
 * Returns all applications for a given family, including:
 *  - The family itself (if it is included in stat_metadata)
 *  - The platform family as an application
 *
 *
 * @param {import('../../types').Family} family
 * @param {import('../../types').Family[]} families
 * @returns {import('../../types').Application[]} Applications, sorted
 */
export default function getAllApplicationsForFamily(family, families) {
    const applications = family?.applications?.length ? [...family.applications] : [];
    applications.sort((a, b) => a.order - b.order);

    if (Object.keys(family.stat_metadata).includes(family.key)) {
        applications.splice(0, 0, {
            key: family.key,
            label: family.label,
        });
    }

    if (family.platform_family_key && family.platform_family_key !== family.key) {
        const platformFamily = families.find(({ key }) => key === family.platform_family_key);
        applications.splice(0, 0, {
            key: platformFamily.key,
            label: platformFamily.label,
        });
    }

    return applications.map((app, i) => ({
        ...app,
        order: i,
    }));
}
